// Theme Colors
// Inicialmente estará en blanco. Más adelante, cuando se inicialice la aplicación, le asignaremos colores de arranque desde las variables CSS.
export const $themeColors = {};

// App Breakpoints
// Inicialmente estará en blanco. Más adelante, cuando se inicialice la aplicación, asignaremos puntos de interrupción de arranque a este objeto desde las variables CSS.
export const $themeBreakpoints = {};

import logotipo from "@images/logos/logo_fondo_oscuro.png";
import logotipowhite from "@images/logos/logo_fondo_claro.png";
import logoShort from "@images/logos/logo_short_fondo_oscuro.svg";

// APP CONFIG
export const $themeConfig = {
  app: {
    appName: "Mi Biografía",
    appLogoImage: logotipo,
    applogoImageWhite: logotipowhite,
    appLogoShort: logoShort,
  },

  layout: {
    skin: "semi-dark", // light, dark, bordered, semi-dark
    routerTransition: "fade", // zoom-fade, slide-fade, fade-bottom, fade, zoom-out, none
    type: "vertical", // vertical, horizontal => proximamente
    contentWidth: "full", // full, boxed

    menu: {
      hidden: false,
      isCollapsed: false,
    },

    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "floating", // static , sticky , floating, hidden
      backgroundColor: "", // BS color options [primary, success, etc]
    },

    footer: {
      type: "static", // static, sticky, hidden
    },

    customizer: true,
    enableScrollToTop: true,

  },
};
